import React, { Fragment, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { Store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css'
import estilos from '../../UsuarioInspectorEnCampo/Asociados/Tabs/TabsInspeccionarComponent.module.css'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import estilosTab from '../../UsuarioInspectorEnCampo/Asociados/Tabs/TabsInspeccionarComponent.module.css'
import MovimientosFabricaComponent from './Movimientos/FabricaComponent';
import MovimientosEnvasadoraComponent from './Movimientos/MovimientosEnvasadoraComponent ';

function VisualizarMovimientos(props) {

    const dispatch = useDispatch()

    const [tabUno, setTabUno] = React.useState(false)
    const [tabDos, setTabDos] = React.useState(false)
    const [tabTres, setTabTres] = React.useState(false)
    const [tabCuatro, setTabCuatro] = React.useState(false)
    const [tabCinco, setTabcinco] = React.useState(false)

    const setearValoresUno = () => {
        setTabUno(true); setTabDos(false); setTabTres(false); setTabCuatro(false); setTabcinco(false);
    }
    const setearValoresDos = () => {
        setTabUno(false); setTabDos(true); setTabTres(false); setTabCuatro(false); setTabcinco(false);
    }
    const setearValoresTres = () => {
        setTabUno(false); setTabDos(false); setTabTres(true); setTabCuatro(false); setTabcinco(false);
    }
    const setearValoresCuatro = () => {
        setTabUno(false); setTabDos(false); setTabTres(false); setTabCuatro(true); setTabcinco(false);
    }
    const setearValoresCinco = () => {
        setTabUno(false); setTabDos(false); setTabTres(false); setTabCuatro(false); setTabcinco(true);
    }

    return (
        <Fragment><br />
            <div className={`row text-center ${estilos.tabsTercerNivel} `}>
                <div className="col">
                    <button type="button" className={`btn ${estilosTab.block}`} onClick={() => setearValoresUno()} style={{ background: tabUno ? '#0e813c' : 'transparent', color: tabUno ? 'white' : 'black' }}>PRODUCCION</button>
                </div>
                <div className="col">
                    <button type="button" className={`btn ${estilosTab.block}`} onClick={() => setearValoresDos()} style={{ background: tabDos ? '#0e813c' : 'transparent', color: tabDos ? 'white' : 'black' }}>FABRICA</button>
                </div>
                <div className="col">
                    <button type="button" className={`btn ${estilosTab.block}`} onClick={() => setearValoresTres()} style={{ background: tabTres ? '#0e813c' : 'transparent', color: tabTres ? 'white' : 'black' }}>ENVASADORA</button>
                </div>
                <div className="col">
                    <button type="button" className={`btn ${estilosTab.block}`} onClick={() => setearValoresCuatro()} style={{ background: tabCuatro ? '#0e813c' : 'transparent', color: tabCuatro ? 'white' : 'black' }}>ALMACEN GRANELES</button>
                </div>
                <div className="col">
                    <button type="button" className={`btn ${estilosTab.block}`} onClick={() => setearValoresCinco()} style={{ background: tabCinco ? '#0e813c' : 'transparent', color: tabCinco ? 'white' : 'black' }}>ALMACEN ENVASADO</button>
                </div>
            </div>
            {
                tabUno ? (
                    <div className={`row text-center ${estilos.tabItem}`}>
                        <div className="container mt-4">
                            {
                                props.trazabilidad.movimientos.PRODUCCION.map((movimiento, index) => {
                                    const tipoMovimiento = Object.keys(movimiento)[0];
                                    const datos = movimiento[tipoMovimiento];

                                    const esAlta = datos.litrosProducidos > 0;
                                    const esBaja = datos.litrosProducidos < 0;

                                    return (
                                        <div key={index} className="card mb-3">
                                            <div className={`card-body ${esAlta ? 'text-success' : esBaja ? 'text-danger' : ''}`}>
                                                <p className="card-text">
                                                    <strong>Producción:</strong> {datos.produccion} - <strong>Fecha Alta:</strong> {datos.fechaAlta}
                                                </p>
                                                <p className="card-text">
                                                    <strong>Inspector:</strong> {datos.inspector}
                                                </p>
                                                <p className="card-text">
                                                    <strong>Fecha Rendimiento:</strong> {datos.fechaRendimiento} - <strong>Inspector Rendimiento:</strong> {datos.inspectorRendimiento}
                                                </p>
                                                <p className="card-text">
                                                    <strong>Litros Producidos:</strong> {datos.litrosProducidos} - <strong>Grado Producido:</strong> {datos.gradoProducido}
                                                </p>
                                                <p className="card-text">
                                                    <strong>Motor:</strong> {datos.motor === 1 ? 'Sí' : 'No'}
                                                </p>
                                                {esAlta && <span className="text-success">&#9650;</span>}
                                                {esBaja && <span className="text-danger">&#9660;</span>}
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>
                    </div>) :
                    tabDos ? (
                        <div className={`row text-center ${estilos.tabItem}`}>
                            <MovimientosFabricaComponent fabrica={props.trazabilidad.movimientos.FABRICA}></MovimientosFabricaComponent>
                        </div>
                    ) :
                        tabTres ? (
                            <div className={`row text-center ${estilos.tabItem}`}>
                                <MovimientosEnvasadoraComponent envasadora={props.trazabilidad.movimientos.ENVASADORA}></MovimientosEnvasadoraComponent>
                            </div>
                        ) :
                            <div></div>

            }
        </Fragment>
    );
};


export default withRouter(VisualizarMovimientos)
